import React from 'react';
import { Table } from 'react-bootstrap';
import { ButtonTooltip } from '../../components/Utils/Tooltips';
import DocumentPreview from '../DocumentPreview/DocumentPreview';
import Icon from '../../components/Icons';

const MissingTimeReportFilterDataTable = ({ attendances, setDocumentModalBody, setDocumentModalShow, resource }) => {
  const renderResult = attendance => {
    const renderObservation = observation => (
      <div style={{ whiteSpace: 'pre-line' }}>{observation}</div>
    );

    const styleButtonTooltip = {
      width: 'auto',
      height: 'auto',
      borderRadius: '10%',
      display: 'initial'
    };

    const renderDocumentButton = (document, docKey, text) => {
      if (!document) return null;
      return (
        <ButtonTooltip
          onClick={() => {
            setDocumentModalBody(
              <DocumentPreview
                documentId={attendance?.[docKey]?.id}
                employeeId={attendance?.[docKey]?.employee_id}
              />
            );
            setDocumentModalShow(true);
          }}
          variant="circle-info"
          className="btn-circle"
          style={styleButtonTooltip}
          toolbarVariant="justify-content-center"
          size="sm"
          text={text}
          disabledTooltip
        >
          <Icon icon="profile" /> {text}
        </ButtonTooltip>
      );
    };

    const cells = [
      { id: 'date', value: attendance.date_formatted, always: true },
      { id: 'shift', value: attendance.shift, always: true },
      { id: 'attendance', value: attendance.attendance_day, always: true },
      { id: 'break', value: attendance.shift_break, always: true },
      { id: 'late', value: attendance.late_workday, show: ['DelayReport', 'MissingTimeReport'].includes(resource) },
      { id: 'early', value: attendance.early_departure, show: ['EarlyDeparturesReport', 'MissingTimeReport'].includes(resource) },
      { id: 'excess', value: attendance.excess_colation, show: resource === 'MissingTimeReport' },
      {
        id: 'comments',
        value: (
          <>
            {renderDocumentButton(attendance?.document, 'overtime_ag_document', 'Ver Pacto H.E')}
            {renderDocumentButton(attendance?.permission_document, 'permission_document', 'Ver Permiso')}
            {renderDocumentButton(attendance?.vacation_docuemnt, 'vacation_docuemnt', 'Ver Vacación')}
            {renderObservation(attendance.observation)}
          </>
        ),
        show: resource === 'MissingTimeReport'
      }
    ];

    return (
      <tr>
        {cells.map(cell =>
          (cell.always || cell.show) && (
            <td key={cell.id} className="text-center align-middle">{cell.value}</td>
          )
        )}
      </tr>
    );
  };

  const renderData = () => {
    return (
      <>
        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              {[
                { label: 'Fecha', always: true },
                { label: 'Jornada Ordinaria', always: true },
                { label: 'Marcas Reales', always: true },
                { label: 'Colación', always: true },
                { label: 'Atrasos', show: ['DelayReport', 'MissingTimeReport'].includes(resource) },
                { label: 'Salida Anticipada', show: ['EarlyDeparturesReport', 'MissingTimeReport'].includes(resource) },
                { label: 'Exceso de Colación', show: resource === 'MissingTimeReport' },
                { label: 'Comentarios', show: resource === 'MissingTimeReport' }
              ].map(col =>
                (col.always || col.show) && (
                  <th key={col.label} className="text-center align-middle">{col.label}</th>
                )
              )}
            </tr>
          </thead>
          <tbody>{attendances?.map(attendance => renderResult(attendance))}</tbody>
        </Table>
      </>
    );
  };

  return <>{renderData()}</>;
};

export default MissingTimeReportFilterDataTable;
